import { fromJS } from 'immutable'

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state')
    if (serializedState === null) {
      return undefined
    }
    return {
      global: fromJS(JSON.parse(serializedState).global),
    }
  } catch (err) {
    return undefined
  }
}

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('state', serializedState)
  } catch (err) {
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/config/localStorage.js